import { useGetEvent } from "@/hooks/session.hooks";
import { useEffect } from "react";
import { useLanguageParam } from "../../utils";
import { useAppDispatch } from "@/store/reducers/use-typed-selector";
import { loadSeries } from "@/store/actions/event/event-actions";

export const useLoadSeries = () => {
	const event = useGetEvent();
	const language = useLanguageParam();
	const eventUuid = event?.uuid;
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (eventUuid) {
			dispatch(loadSeries(eventUuid, language));
		}
	}, [eventUuid, language, dispatch]);
};